<template>
  <v-container fluid>

    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_detail" @keydown.esc="dialog_detail = false" max-width="800px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('kakaodetail_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_detail = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <vue-json-pretty
                :data="iamData"                  
                >
              </vue-json-pretty>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_detail = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>        


    <v-row dense align="center">
      <v-col cols="12" md="2" class="pa-0">
        <v-btn icon @click="back"><v-icon>mdi-arrow-left</v-icon></v-btn>
        <label class="menunamestyle">{{$t('kakaodetail_label2')}}</label>
      </v-col>
      <v-spacer/>
      <v-col cols="12" md="4" class="pa-0">
        <v-text-field 
          dense single-line clearable
          @keyup.enter="search_run" 
          v-model="search" 
          :placeholder="$t('kakaodetail_label3')"
          outlined height="43"
          color="#808080"
          hide-details
          />
      </v-col>
  </v-row>

  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>
    
  <v-row align="start">
    <v-col class="pa-1">
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        >
        <template v-slot:header.to>
          <label class="cheader_normal" >{{$t("kakaodetail_col1")}}</label>
        </template>
        <template v-slot:header.requestStatusDesc>
          <label class="cheader_normal" >{{$t("kakaodetail_col2")}}</label>
        </template>
        <template v-slot:header.messageStatusDesc>
          <label class="cheader_normal" >{{$t("kakaodetail_col3")}}</label>
        </template>
        <template v-slot:header.requestTime>
          <label class="cheader_normal" >{{$t("kakaodetail_col4")}}</label>
        </template>
        <template v-slot:header.kakaoState>
          <label class="cheader_normal" >{{$t("kakaodetail_col5")}}</label>
        </template>

        <template v-slot:item.kakaoState="{ item }">  
          <v-icon small @click="getKakaoinfo(item.messageId)">mdi-link</v-icon>
        </template>     

      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="center" justify="center">
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
  </v-row>

  </v-container>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'
export default {

    components:{
      VueJsonPretty
    },  

    data: () => ({
      REQID: null,
      EVENT_IDX: null,
      COMIDX: null,
      dialog_detail:false,
      iamData:{},

      //필수 페이징 파라메터
      loading : false,    //로딩 표시

      //테이블 정의
      headers: [
        {text: '연락처',   value: 'to', sortable: false, align:'center', width:150},
        {text: '발송상태', value: 'requestStatusDesc', sortable: false, align:'center', width:100},
        {text: '수신상태', value: 'messageStatusDesc', sortable: false, align:'center', width:100 },
        {text: '발송일시', value: 'requestTime', sortable: false, align:'center', width:200},
        {text: '상세', value: 'kakaoState', sortable: false, align:'center', width:100},
      ],
      itemList: [],
      
      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 100,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    
      
      
      SEARCH_COM_IDX: '',
      SEARCH_COM_NAME: '',
      grade : 0,
      
    }),

    mounted(){
      
      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){

    },

    methods: {


      //발송내역 상세 확인
      getKakaoinfo(msgid){
        

          this.$http.post(this.$host+'/api/KakaoMessageDetail',{
            MSGID: msgid
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.iamData = result.data.resultData;
              this.dialog_detail = true;
              

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });        
      },            

      back(){
        this.$router.back();
      },

      loadpage(p){
          
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          
          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/KakaoRequestList',{
              ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , EVENT_IDX: this.EVENT_IDX
            , COMIDX: this.COMIDX
            , REQID: this.REQID
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              const list = result.data.resultData.messages;
              this.totalcnt = list.length;
              list.forEach(element => {

                if(this.$i18n.locale != 'ko'){
                  if(element.requestStatusDesc == '성공'){
                    element.requestStatusDesc = 'Success';
                    element.messageStatusDesc = 'Sent Successfully' ;
                  }else{
                    element.requestStatusDesc == 'Fail';
                    element.messageStatusDesc = 'Sent Fail' ;
                  }
                }

                this.itemList.push(element); 
              });

              //요걸 나중에 해줘야 무한반복이 안된다.
              this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        this.REQID      = this.$route.query.rid;
        this.EVENT_IDX  = this.$route.query.event;
        this.COMIDX     = this.$route.query.com;

        //첫페이지 로드
        this.loadpage(1);
      },      

      //검색
      search_run(){
        this.loadpage(1);
      },
      

    },
  
}
</script>


<style lang="css">
  td{
    height: 36px !important;
  }
</style>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

</style>